// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OperationCondition } from './operationCondition';
import { EmissionType } from './emissionType';
import { DeterminationType } from './determinationType';
import { BelowLdLq } from './belowLdLq';
import { DataType } from './dataType';
import { MonitoringType } from './monitoringType';


export interface AirEntriesUpdateBody { 
    /**
     * The air entry value
     */
    value: number;
    /**
     * The air entry nit value
     */
    unit: string;
    belowLdLq: AirEntriesUpdateBody.BelowLdLqEnum | null;
    determinationType: DeterminationType;
    dataType: DataType;
    emissionType: EmissionType;
    monitoringType: MonitoringType;
    operationCondition: OperationCondition;
    /**
     * The oxygen content
     */
    oxygenContent: number;
}
export namespace AirEntriesUpdateBody {
    export type BelowLdLqEnum = 'LD' | 'LQ';
    export const BelowLdLqEnum = {
        LD: 'LD' as BelowLdLqEnum,
        LQ: 'LQ' as BelowLdLqEnum
    };
}


